module.exports = __webpack_public_path__ + "media/images/mobile/home/hot_tag-9563dd82cf9b3d2004e93b04771ee44e.png";